import { useEffect, useRef, useState } from 'react';
import { PIXEL_IMAGE } from '~/constants';
import { useInViewport } from '~/hooks/useInViewport';
import theme from '~/styles/theme';

/**
 * @param {{ fallbackSrc?: string, src?: string }} props
 */
export const useLazyLoad = ({ fallbackSrc, src }) => {
  const [componentSrc, setComponentSrc] = useState('');
  const [imageData, setImageData] = useState({ 'data-loading': '' });
  const [styles, setStyles] = useState(theme.lazyLoad.Loading);
  const componentRef = useRef();
  const { isInView } = useInViewport(componentRef);

  // Lazy load component
  useEffect(() => {
    if (isInView && componentSrc !== src) {
      setComponentSrc(src);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src, isInView]);

  const onError = () => {
    if (!isInView) {
      return;
    }

    if (componentSrc === src && fallbackSrc) {
      setComponentSrc(fallbackSrc);
      setStyles({});
    } else if (!fallbackSrc || componentSrc === fallbackSrc) {
      setComponentSrc(PIXEL_IMAGE);
      setStyles(theme.lazyLoad.Error);
    }
    setImageData({ 'data-placeholder': '' });
  };

  const onLoad = () => {
    if (componentSrc === src) {
      setStyles({});
      setImageData({});
    }
  };

  return {
    imageData,
    onError,
    onLoad,
    ref: componentRef,
    src: componentSrc,
    styles,
  };
};
